/* @flow */

import Immutable from 'immutable';
import { LoadingConstants } from '../constants/loading_constants';

const loadingTypes = Immutable.Set.of('blocking', 'full', 'sidebar', 'silent');

const LoadingActionCreators = {
  loadingStart: function(id: string, loadingType: LoadingType): Object {
    if (!loadingTypes.has(loadingType)) {
      // TODO remove once we fix all places that cause it to trigger
      try {
        throw new Error('Unexpected loading type: ' + loadingType);
      } catch (e) {
        // log with stack trace
        //Raven.captureException(e);
      }
    }
    return {
      type: LoadingConstants.LOADING_START,
      id,
      loadingType
    };
  },
  loadingStop: function(id: string): Object {
    return {
      type: LoadingConstants.LOADING_STOP,
      id
    };
  }
};

export { LoadingActionCreators };
